"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentKey = getCurrentKey;
exports.getTencentMapKey = getTencentMapKey;
exports.loadTencentMap = loadTencentMap;
exports.notifyAllKeysExhausted = notifyAllKeysExhausted;
exports.rotateToNextKey = rotateToNextKey;
exports.tencentJsonp = tencentJsonp;
var _systemConfig = require("@/api/systemConfig");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var loadPromise = null;
var cachedKey = null; // 地图 JS 脚本加载时使用（固定一个）
var cachedKeys = []; // API 调用轮换时使用（多 AK）
var cachedNames = []; // 对应每个 AK 的姓名
var keyIndex = 0;
var jsonpCallbackCounter = 0;
var feishuNotified = false; // 是否已发过耗尽通知（当天只发一次）

/**
 * 通过 JSONP 方式调用腾讯地图 WebService API.
 * 腾讯的 apis.map.qq.com 不支持 CORS, 浏览器 fetch/getJSON 会被 CORS 拦截,
 * 但 WebService 提供了 output=jsonp&callback=xxx 模式, 通过 <script> 加载绕开 CORS.
 * 同时绕开了 qq.maps.SearchService/Geocoder 内部 JSONP 异步 reject 触发
 * 的 "Cannot read properties of undefined (reading 'type')" Uncaught 错误.
 * 文档: https://lbs.qq.com/service/webService/webServiceGuide/overview
 *      https://lbs.qq.com/service/webService/webServiceGuide/search/webServiceSearch
 *      https://lbs.qq.com/service/webService/webServiceGuide/webServiceGcoder
 */
function tencentJsonp(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$timeoutMs = _ref.timeoutMs,
    timeoutMs = _ref$timeoutMs === void 0 ? 10000 : _ref$timeoutMs,
    _ref$marker = _ref.marker,
    marker = _ref$marker === void 0 ? 'tx-map-jsonp' : _ref$marker;
  return new Promise(function (resolve, reject) {
    var callbackName = "__txJsonp_".concat(Date.now(), "_").concat(++jsonpCallbackCounter);
    window[callbackName] = function (data) {
      cleanup();
      delete window[callbackName];
      resolve(data);
    };
    var script = document.createElement('script');
    script.setAttribute(marker, 'true');
    script.async = true;
    // 拼接 callback 和 output=jsonp
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    script.src = "".concat(url).concat(sep, "output=jsonp&callback=").concat(callbackName);
    var timeout = setTimeout(function () {
      cleanup();
      delete window[callbackName];
      reject(new Error("\u817E\u8BAF\u5730\u56FE WebService JSONP \u8D85\u65F6: ".concat(url)));
    }, timeoutMs);
    function cleanup() {
      clearTimeout(timeout);
      if (script.parentNode) script.parentNode.removeChild(script);
    }

    // JSONP 失败（status !== 0 时腾讯仍然会调用 callback，所以 success 路径一定能走通，
    // 这里 onerror 只用于网络/解析失败场景）
    script.onerror = function () {
      cleanup();
      delete window[callbackName];
      reject(new Error("\u817E\u8BAF\u5730\u56FE WebService JSONP \u52A0\u8F7D\u5931\u8D25: ".concat(url)));
    };
    document.head.appendChild(script);
  });
}
function loadTencentMap() {
  if (window.qq && window.qq.maps && window.qq.maps.Map) {
    return Promise.resolve(window.qq.maps);
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = fetchKeyAndLoad();
  return loadPromise;
}

/**
 * 仅获取后端配置的腾讯地图 Key（支持多 AK 轮换），返回当前 key。
 * 每次调用返回下一个可用 key（轮换策略）。
 * 用于直接调用 WebService API（如 /ws/place/v1/search），
 * 这样可以绕开 qq.maps.SearchService JSONP 异步 reject 导致的
 * "Cannot read properties of undefined (reading 'type')" 内部错误。
 */
function getTencentMapKey() {
  if (cachedKeys.length > 0) {
    var key = cachedKeys[keyIndex];
    return Promise.resolve(key);
  }
  return (0, _systemConfig.getTxMapKeyApi)().then(function (res) {
    var raw = res && (res.value || res.data || res.key);
    if (!raw) throw new Error('未获取到腾讯地图 Key');
    // 支持两种格式：
    // 1. 多行：姓名：手机号：AK（每行一个 AK）
    // 2. 单行：多个 AK 用换行/逗号分隔
    var keys = [];
    var names = [];
    String(raw).split(/[\r\n]+/).forEach(function (line) {
      var trimmed = line.trim();
      if (!trimmed) return;
      var parts = trimmed.split('：');
      var ak = '';
      var name = '';
      if (parts.length >= 3) {
        name = parts[0].trim();
        ak = parts[parts.length - 1].trim();
      } else if (parts.length === 2 && isValidTxMapKey(parts[1].trim())) {
        ak = parts[1].trim();
        name = parts[0].trim();
      } else {
        ak = trimmed;
      }
      if (ak && isValidTxMapKey(ak)) {
        keys.push(ak);
        names.push(name);
      }
    });
    if (keys.length === 0) {
      throw new Error("\u672A\u5728\u7CFB\u7EDF\u914D\u7F6E\u4E2D\u627E\u5230\u5408\u6CD5\u7684\u817E\u8BAF\u5730\u56FE Key");
    }
    cachedKeys = keys;
    cachedNames = names;
    feishuNotified = false;
    keyIndex = 0;
    return cachedKeys[keyIndex];
  });
}

/**
 * 当当前 key 触发配额超限（status=121）时，切换到下一个 key 并返回。
 * 若已遍历完所有 key，则返回 null 并触发飞书通知。
 */
function rotateToNextKey() {
  if (cachedKeys.length === 0) return null;
  keyIndex = (keyIndex + 1) % cachedKeys.length;
  var newKey = cachedKeys[keyIndex];
  return newKey;
}

/**
 * 所有 AK 均已耗尽，发送飞书通知（每天只发一次）。
 */
function notifyAllKeysExhausted() {
  return _notifyAllKeysExhausted.apply(this, arguments);
}
/**
 * 返回当前 key（不切换）。
 */
function _notifyAllKeysExhausted() {
  _notifyAllKeysExhausted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var exhaustedNames, content, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(feishuNotified || cachedNames.length === 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          exhaustedNames = cachedNames.filter(function (n) {
            return n;
          }).join('、');
          content = exhaustedNames ? "\u4EE5\u4E0B\u4EBA\u5458\u7684\u817E\u8BAFAK\u5DF2\u8017\u5C3D\uFF1A".concat(exhaustedNames) : "\u817E\u8BAF\u5730\u56FEAK\u5DF2\u5168\u90E8\u8017\u5C3D\uFF0C\u8BF7\u53CA\u65F6\u66F4\u65B0";
          _context.p = 2;
          _context.n = 3;
          return (0, _systemConfig.sendFeiShuNotifyApi)(content);
        case 3:
          feishuNotified = true;
          console.log('[TencentMap] 飞书通知已发送:', content);
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error('[TencentMap] 飞书通知发送失败:', _t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _notifyAllKeysExhausted.apply(this, arguments);
}
function getCurrentKey() {
  if (cachedKeys.length === 0) return null;
  return cachedKeys[keyIndex];
}
function buildSdkUrl(key) {
  // 旧版 JS API 入口 (v2.exp). 主入口脚本内部会做 document.write 注入 main.js
  // (https://mapapi.qq.com/jsapi_v2/2/4/160/main.js); 该 document.write 在动态
  // appendChild 进来的 script 里会被现代浏览器忽略, 所以这里我们改为先注入
  // bootstrap (3 KB), 等 window.qq.maps.__load 出现后, 主动再注入 main.js, 跳过
  // bootstrap 的 document.write, 让 main.js 自己调用 qq.maps.__load(...) 把所有
  // API 挂到 window.qq.maps.* 上. 这是腾讯 v2 系列 API 唯一可用的动态加载方式.
  // 迁移到 GL JS (window.TMap.*) 后, 这层 hack 就可以拆掉.
  return "https://map.qq.com/api/js?v=2.exp&key=".concat(key);
}
function buildMainJsUrl(key) {
  // main.js 中的 oa 数组与 bootstrap 中的版本号/模块路径一致; 这里我们固定一个
  // 长期可用的版本 (2.4.160) 的 main.js. 如果以后腾讯升版, key 的签名校验仍由
  // bootstrap 内的 __load 函数完成, 我们不会绕过 key 验证.
  return "https://mapapi.qq.com/jsapi_v2/2/4/160/main.js";
}
function isValidTxMapKey(key) {
  if (!key || typeof key !== 'string') return false;
  // 腾讯地图 key 形如 XXXXX-XXXXX-XXXXX-XXXXX-XXXXX[-XXXXX]，每段 5 字符
  // 常见两种:
  //   - 5 段 25 字符(老格式): XXXXX-XXXXX-XXXXX-XXXXX-XXXXX
  //   - 6 段 30 字符(当前格式): XXXXX-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX
  // 也允许去掉中划线后再算(25 / 30 个字母数字)
  var stripped = key.replace(/-/g, '');
  var dashedOk = /^(?:[A-Za-z0-9]{5}-){4}[A-Za-z0-9]{5}$/.test(key) || /^(?:[A-Za-z0-9]{5}-){5}[A-Za-z0-9]{5}$/.test(key);
  return dashedOk || /^[A-Za-z0-9]{25}$/.test(stripped) || /^[A-Za-z0-9]{30}$/.test(stripped);
}
function fetchKeyAndLoad() {
  return (0, _systemConfig.getTxMapKeyApi)().then(function (res) {
    var raw = res && (res.value || res.data || res.key);
    if (!raw) {
      throw new Error('未获取到腾讯地图 Key，请在系统配置中设置');
    }
    var keys = [];
    var names = [];
    String(raw).split(/[\r\n]+/).forEach(function (line) {
      var trimmed = line.trim();
      if (!trimmed) return;
      var parts = trimmed.split('：');
      var ak = '';
      var name = '';
      if (parts.length >= 3) {
        name = parts[0].trim();
        ak = parts[parts.length - 1].trim();
      } else if (parts.length === 2 && isValidTxMapKey(parts[1].trim())) {
        ak = parts[1].trim();
        name = parts[0].trim();
      } else {
        ak = trimmed;
      }
      if (ak && isValidTxMapKey(ak)) {
        keys.push(ak);
        names.push(name);
      }
    });
    if (keys.length === 0) {
      throw new Error("\u817E\u8BAF\u5730\u56FE Key \u683C\u5F0F\u4E0D\u5408\u6CD5\uFF0C\u8BF7\u5728\u7CFB\u7EDF\u914D\u7F6E\u4E2D\u586B\u5199\u6B63\u786E\u7684 Key");
    }
    var key = keys[0];
    cachedKey = keys[0];
    cachedKeys = keys;
    cachedNames = names;
    console.log('[TencentMap] 使用后端配置的 Key:', keys[0]);
    console.log('[TencentMap] 共检测到', keys.length, '个 Key，将用于 API 调用轮换');
    console.log('[TencentMap] 即将注入 bootstrap:', buildSdkUrl(keys[0]));
    console.log('[TencentMap] bootstrap 完成后将再注入 main.js:', buildMainJsUrl(keys[0]));
    return loadScript(buildSdkUrl(key), 'data-qq-map-bootstrap').then(function () {
      if (!window.qq || !window.qq.maps || !window.qq.maps.__load) {
        // bootstrap 没正确设置 __load, 几乎不可能; 抛错由 waitForQqMap 兜底
        console.warn('[TencentMap] bootstrap 未提供 __load 钩子, main.js 可能挂不上 API');
      }
      return loadScript(buildMainJsUrl(keys[0]), 'data-qq-map-main');
    }).then(function () {
      return waitForQqMap();
    });
  }).then(function () {
    return window.qq.maps;
  }).catch(function (err) {
    // 失败时清除 promise，以便下次调用重新尝试
    loadPromise = null;
    throw err;
  });
}
function loadScript(src, marker) {
  var dataAttr = marker || 'data-qq-map';
  return new Promise(function (resolve, reject) {
    var existing = document.querySelector("script[".concat(dataAttr, "]"));
    if (existing) {
      existing.parentNode.removeChild(existing);
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute(dataAttr, 'true');
    script.src = src;
    var timeout = setTimeout(function () {
      reject(new Error("\u817E\u8BAF\u5730\u56FE\u811A\u672C ".concat(src, " \u52A0\u8F7D\u8D85\u65F6\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC")));
    }, 20000);
    script.onload = function () {
      clearTimeout(timeout);
      resolve();
    };
    script.onerror = function () {
      clearTimeout(timeout);
      reject(new Error("\u817E\u8BAF\u5730\u56FE\u811A\u672C ".concat(src, " \u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5 Key \u662F\u5426\u6B63\u786E")));
    };
    document.head.appendChild(script);
  });
}
function waitForQqMap() {
  var maxRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return new Promise(function (resolve, reject) {
    var retry = 0;
    var mainBootstrapRetried = false;
    var timer = setInterval(function () {
      var api = window.qq && window.qq.maps;
      if (api && api.Map && api.LatLng && api.Geocoder && api.Marker) {
        clearInterval(timer);
        console.log('[TencentMap] 加载成功', {
          Map: !!api.Map,
          LatLng: !!api.LatLng,
          Geocoder: !!api.Geocoder,
          Marker: !!api.Marker
        });
        resolve();
        return;
      }
      retry += 1;
      // 关键兜底：bootstrap 注入成功了，但因 document.write 被禁用 main.js 没注入，
      // 此时 window.qq.maps 已有但缺少 Map/LatLng。检测到这种情况后主动补救注入 main.js，
      // 让 main.js 执行它顶部的 qq.maps.__load(ek) 把所有 API 挂上去。
      if (!mainBootstrapRetried && api && api.__load && !api.Map) {
        mainBootstrapRetried = true;
        console.warn('[TencentMap] bootstrap 成功但 main.js 未注入 (document.write 被浏览器拦截), 主动补救注入 main.js');
        loadScript(buildMainJsUrl(null), 'data-qq-map-main-retry').then(function () {
          // 重置 retry, 让后续轮询继续检查 api.Map 是否出现
          retry = 0;
        }).catch(function (err) {
          return console.error('[TencentMap] 补救加载 main.js 失败:', err);
        });
        return;
      }
      if (retry === 5) {
        console.warn('[TencentMap] window.qq.maps 状态:', api && Object.keys(api).slice(0, 20));
      }
      if (retry === 15) {
        console.warn('[TencentMap] window 已有 qq 相关键:', Object.keys(window).filter(function (k) {
          return k.toLowerCase().includes('qq');
        }));
      }
      if (retry >= maxRetry) {
        clearInterval(timer);
        console.error('[TencentMap] 等待 window.qq.maps.Map/LatLng 等 API 超时, window.qq:', window.qq);
        reject(new Error('腾讯地图初始化失败，请查看 Console 中的诊断信息'));
      }
    }, interval);
  });
}